import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

const TableSelectDialog = ({
  open,
  onOpenChange,
  tables,
  tableOrders,
  selectedTable,
  onSelectTable,
  onOpenBilling
}) => {
  const getTableTotal = (tableId) => (tableOrders[tableId] || []).reduce((sum, o) => sum + o.total_amount, 0);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>Select Table</DialogTitle>
        </DialogHeader>
        <Tabs defaultValue="all">
          <TabsList>
            <TabsTrigger value="all">All ({tables.length})</TabsTrigger>
            <TabsTrigger value="available">Available ({tables.filter(t => t.status === 'available').length})</TabsTrigger>
            <TabsTrigger value="occupied">Running ({tables.filter(t => t.status === 'occupied').length})</TabsTrigger>
          </TabsList>
          <TabsContent value="all" className="mt-4">
            <div className="grid grid-cols-5 gap-3">
              {tables.map(table => (
                <Card 
                  key={table.id} 
                  className={`cursor-pointer transition-all ${
                    table.status === 'occupied' ? 'border-orange-400 bg-orange-50' : 'hover:bg-accent'
                  } ${selectedTable?.id === table.id ? 'ring-2 ring-primary' : ''}`}
                  onClick={() => onSelectTable(table)}
                  data-testid={`table-select-${table.id}`}
                >
                  <CardContent className="p-3 text-center">
                    <p className="font-bold text-lg">T{table.table_number}</p>
                    <Badge className={table.status === 'available' ? 'bg-green-100 text-green-700' : 'bg-orange-100 text-orange-700'}>
                      {table.status === 'occupied' ? 'Running' : table.status}
                    </Badge>
                    {tableOrders[table.id] && (
                      <div className="mt-2 text-xs">
                        <p className="text-orange-700 font-medium">{tableOrders[table.id].length} orders</p>
                        <p className="font-bold">₹{getTableTotal(table.id).toFixed(0)}</p>
                      </div>
                    )}
                  </CardContent>
                </Card>
              ))}
            </div>
          </TabsContent>
          <TabsContent value="available" className="mt-4">
            <div className="grid grid-cols-5 gap-3">
              {tables.filter(t => t.status === 'available').map(table => (
                <Card key={table.id} className="cursor-pointer hover:bg-accent" onClick={() => onSelectTable(table)}>
                  <CardContent className="p-3 text-center">
                    <p className="font-bold text-lg">T{table.table_number}</p>
                    <Badge className="bg-green-100 text-green-700">Available</Badge>
                  </CardContent>
                </Card>
              ))}
            </div>
          </TabsContent>
          <TabsContent value="occupied" className="mt-4">
            <div className="grid grid-cols-5 gap-3">
              {tables.filter(t => t.status === 'occupied').map(table => (
                <Card key={table.id} className="cursor-pointer border-orange-400 bg-orange-50" onClick={() => onOpenBilling(table)}>
                  <CardContent className="p-3 text-center">
                    <p className="font-bold text-lg">T{table.table_number}</p>
                    <Badge className="bg-orange-100 text-orange-700">Running</Badge>
                    {tableOrders[table.id] && (
                      <div className="mt-2 text-xs">
                        <p className="text-orange-700 font-medium">{tableOrders[table.id].length} orders</p>
                        <p className="font-bold">₹{getTableTotal(table.id).toFixed(0)}</p>
                      </div>
                    )}
                  </CardContent>
                </Card>
              ))}
            </div>
          </TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
};

export default TableSelectDialog;
